<template>

	<div class="card">
		<slot>

		</slot>
		<h2>
			<span class="title" :title="cardData.title">
				{{cardData.title}}
			</span>
			<span class="key" v-for="key in cardData.keys" v-show="key" :key="key" >{{key|bspTableFilter({'1':'dict', '2':dicts})}}</span>
		</h2>
		<div class="carContent">
			<div class="radio" v-if="cardData.process&&cardData.process.state==0">
						<span class="label">确认意见：</span>
        <el-radio-group v-model="form.radio">
          <el-radio :label="1">确认</el-radio>
          <el-radio :label="2">返回中智</el-radio>
        </el-radio-group>
					</div>
					<div class="radio" v-if="cardData.process&&cardData.process.state==1">
						<span class="label">审批意见：</span>
            <el-radio-group v-model="form.radio">
              <el-radio :label="1">同意</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
					</div>
					<div class="tip" v-if="cardData.process&&cardData.process.state>1">
						<div>
							<img style="margin-bottom: 10px;" v-if="cardData.process.state==2||cardData.process.state==3||cardData.process.state==6" src="@/assets/img/salary/wancheng.png" alt="" srcset="">
							<img style="margin-bottom: 10px;" v-else src="@/assets/img/salary/icon-daweiwancheng.png" alt="" srcset="">
						</div>
						<div>
							<p v-if="cardData.process.state==2">您已提交审批意见，现在流程到 {{cardData.process.processList[cardData.process.currentIndex].roleName}}</p>
							<p v-if="cardData.process.state==3">{{labels[4]}}已完成审核</p>
							<p v-if="cardData.process.state==4">您已驳回审批意见</p>
							<p v-if="cardData.process.state==5">{{labels[4]}}未完成</p>
              <p v-if="cardData.process.state==6">您创建的薪资批次，现在流转到 {{cardData.process.processList[cardData.process.currentIndex].roleName}}</p>
              <p v-if="cardData.process.state==7">您创建的薪资批次，流转到 {{cardData.process.processList[cardData.process.currentIndex].roleName}}处被驳回</p>

            </div>
					</div>
					<div class="info">
						<div>
							<span>{{labels[0]}}：</span>
							<span>{{cardData.info.num1}}</span>
						</div>
						<div>
							<span>{{labels[1]}}：</span>
							<span>{{cardData.info.num2}}</span>
						</div>
						<div>
							<span>{{labels[2]}}：</span>
							<span>{{cardData.info.num3}}</span>
						</div>
						<div>
							<span>{{labels[3]}}：</span>
							<span>{{cardData.info.num4}}</span>
						</div>
					</div>
					<div class="textarea" v-if="cardData.process&&cardData.process.state==1||cardData.process&&cardData.process.state==0">
						<span class="label" style="vertical-align: top;padding-top:4px;">备注：</span>
						<el-input type="textarea" style="width:calc(100% - 65px)" v-model="form.adv"></el-input>
					</div>
					<div class="process" v-if="cardData.process" :class="{'other':cardData.process&&cardData.process.state>1,'sure':cardData.process&&cardData.process.state==0}">
						<span class="label">审批流程：</span>

						<span v-for="(list,index) in cardData.process.processList" :key="index" :class="{'iscurrent':index<=cardData.process.currentIndex&&cardData.process.state==3,'fail':(cardData.state==4||cardData.state==5||cardData.state==7)}">
							<el-tooltip class="item" effect="light"  placement="bottom">
									<div slot="content">
										<p>审&nbsp;&nbsp;批&nbsp;&nbsp;人：{{list.roleName}}</p>
										<p style="margin-top: 4px;">审批时间：{{list.approvalTime}}</p>
										<p style="margin-top: 4px;">审批意见：{{list.rejectReason}}</p>
										</div>
								<span :class="{'iscurrent':(index<=cardData.process.currentIndex&&(cardData.process.state!=4))}">{{list.roleName}}	</span>
							</el-tooltip>
							<el-tooltip class="item" effect="light" content="当前示意到HR2环节驳回" placement="bottom">
								<img v-if="list==cardData.process.current&&(cardData.state==4||cardData.state==5||cardData.state==7)" src="@/assets/img/salary/guanbi.png" />
							</el-tooltip>
							<span class="proDot">></span>
						</span>

					</div>
					<div class="save" v-if="cardData.process&&cardData.process.state==1||cardData.process&&cardData.process.state==0">
						<el-button type="primary" @click="submitApproval">提交</el-button>
					</div>

		</div>

	</div>

</template>

<script>
	import {mapGetters} from "vuex";
  import {submitApproval} from "@/api/wage/approval.js";
  export default {
		name: "card",
		props: {
			cardData: {
				type: Object,
				default: {},
			},
			radio: {
        type: String,
        default: '',
      },
      index: {
        type: Number,
        default: 0,
      },
			labels: {
				type: Array,
				default: [],
			}
		},
		data() {
			return {
				form: {
					radio: '',
					adv: '',
          batchId:this.cardData.id
				}
			};
		},
    mounted() {
      console.log(this.cardData);
    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
		methods: {

      submitApproval(){
        if(this.form.radio!='2'&&this.form.radio!='1'){
          this.$message.error("请勾选审批意见")
          return;
        }
        if(this.form.radio=='2'&&this.form.adv.length<1){
          this.$message.error("请填写驳回备注")
          return;
        }
        if(this.form.adv.length>250){
          this.$message.error("审批备注不能超过200个字符");
          return;
        }
          this.$confirm('是否确认提交?','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            const params = {
              ...this.form,
              type: '2'
            }
              submitApproval(params).then(res => {
                console.log(res)
                this.$emit("toParent",this.index,res.data.data)
                this.$message.success({
                  message: "审批完成",//提示的信息
                  offset:100,
                  type:'success',
                });

              });
            }
          )

      }

		}
	};
</script>

<style scoped>
	.card {
		border: 1px solid rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 5px 0px rgba(203, 201, 201, 0.5);
		border-radius: 4px;
		box-sizing: border-box;
		 width:calc(50% - 10px);
		 min-width: 500px;
		/*min-width: 380px; */
		margin-right: 20px;
		margin-bottom: 20px;
		min-height: auto;
		background: #fff;
		position: relative;
		overflow: hidden;
	}
	.card:nth-of-type(2n){
		margin-right: 0;
	}
	h2 {
		border-bottom: 4px solid #F3F3F3;
    height: 36px;
    line-height: 1.5;
    border-bottom: 4px solid #F3F3F3;
    padding: 6px 14px 14px 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
	}

	h2>span {
		vertical-align: middle;
	}

	.title {
		font-size: 16px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 22px;
		margin-right: 8px;
    max-width: 300px;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;

	}

	h2>.key {
		border-radius: 2px;
		padding: 1px 4px;
		font-size: 10px;
		font-weight: 300;
		line-height: 14px;
		margin-left: 5px;
	}

	h2>.key:nth-of-type(2) {
		border: 1px solid rgba(255, 0, 0, 1);
		color: rgba(255, 0, 0, 1)
	}
  h2>.key{
    border: 1px solid rgba(255, 221, 0,1);
    color: rgb(255, 221, 0)
  }
	h2>.key:nth-of-type(3) {
		border: 1px solid rgba(1, 167, 59, 1);
		color: rgba(1, 167, 59, 1);
	}

	h2>.key:nth-of-type(4) {
		border: 1px solid rgba(241, 137, 27, 1);
		color: rgba(241, 137, 27, 1);
	}

	.radio {
		padding: 8px 0 6px;
	}

	.card .label {
		display: inline-block;
		font-size: 13px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
		width: 65px;
		text-align: right;
	}

	.info {
		display: flex;
		background: rgba(243, 243, 243, 1);
		border-radius: 4px;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-top: 2px;
	}

	.info>div {
		width: calc(50% - 45px);
		display: flex;
		justify-content: space-between;
		padding: 7px 10px 6px 7px;
	}

	.info>div>span:nth-of-type(1) {
		font-size: 13px;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.info>div>span:nth-of-type(2) {
		font-size: 13px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.textarea {
		margin-top: 10px;
	}

	.process {
		padding-top: 6px;
	}

	.process>span {
		font-size: 13px;
		font-weight: 600;
    color: #666;
    line-height: 18px;
	}

	.process>span.fail.iscurrent {
		color: rgba(255, 0, 0, 1);
	}

	.process>span.fail img {
		margin-left: 4px;
	}


		.process>.iscurrent~span span ,.process>.iscurrent>span{
			color: #666;
		}
     .process >span>span.iscurrent{
       color: rgba(64,158,255,1);
     }

		.process>span:nth-last-of-type(1) .proDot {
			display: none;
		}


	.process>span>span {
    color: #666;
		padding: 0 4px;
	}

	.sure {
		visibility: hidden;
	}

	.save {
		margin-top: 10px;
		text-align: center;
	}

	.tip {
		padding-top: 30px;
		padding-bottom: 27px
	}

	.tip>div {
		text-align: center;
	}

	.tip>div img {
		display: block;
		margin: 0 auto 6px;
		width: 30px;
	}

	.tip>div p {
		font-size: 13px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}
 .carContent{
        padding:15px 100px 15px 21px;
    }
	.other {
		padding-top: 16px;
	}
</style>
